import { default as SweetAlert } from "sweetalert2";

export default SweetAlert.mixin({
    heightAuto: false,
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
        confirmButton: 'btn btn-primary ml-3',
        cancelButton: 'btn btn-cancel',
    }
});

export const SweetAlertNoStyle = SweetAlert.mixin({
    heightAuto: false,
});

export const SweetAlertTailwind = SweetAlert.mixin({
    heightAuto: false,
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
        confirmButton: 'tw-btn-primary',
        cancelButton: 'tw-btn-secondary-gray',
        actions: 'tw-flex tw-gap-2',
        input: 'input-base tw-w-auto'
    }
});